/*
import {
  hf,
  hfDTM,
  hfXLS,
  ht,
  _cv_60___Mz,
} from 'lib';
*/
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as hfXLS from "./_hfXLS";

import * as ihd from './ihd';

import * as icvI1z___Mz from './icvI1z___Mz';

export const eptExlAsync = async (pz: { // 利用者数一覧
  _31r_fst: ht.n,
  yearMth: ht.s,
//  i1zrs: ht.ls,
}) => { //

  const _i1zrs = await icvI1z___Mz.loadI1zrLsAsync({
    _31r_fst: pz._31r_fst,
    yearMth: pz.yearMth,
    lwrType: 1,
  });

  const _fileName = `利用者数一覧_${hfDTM.f(hfDTM.getTdy(), 'YYYYMMDD')}.xlsx`;
  const _shtName = `利用者数一覧`;

  const _hdrs = [
    { key: 1100, header: '曜日', width: 5, style: {} },
    { key: 1200, header: '日付区分', width: 5, style: {} },
    { key: 1300, header: '日付', width: 5, style: {} },
    { key: 1400, header: '時間帯', width: 20, style: {} },
    { key: 1500, header: '利用区分', width: 20, style: {} },
    { key: 1600, header: '部屋名', width: 20, style: {} },
    { key: 2110, header: '男性', width: 5, style: {} },
    { key: 2120, header: '女性', width: 5, style: {} },
    { key: 2210, header: '幼児', width: 5, style: {} },
    { key: 2220, header: '小学生', width: 5, style: {} },
    { key: 2230, header: '中学生', width: 5, style: {} },
    { key: 2240, header: '高校生', width: 5, style: {} },
    { key: 2250, header: '大学生', width: 5, style: {} },
    { key: 2260, header: '一般男性', width: 5, style: {} },
    { key: 2270, header: '一般女性', width: 5, style: {} },
    { key: 2280, header: '65歳以上男性', width: 5, style: {} },
    { key: 2290, header: '65歳以上女性', width: 5, style: {} },
    { key: 2310, header: '区内', width: 5, style: {} },
    { key: 2320, header: '区外', width: 5, style: {} },
    { key: 2330, header: '市外', width: 5, style: {} },
    { key: 3100, header: '予約ID', width: 10, style: {} },
    { key: 3200, header: '団体名', width: 20, style: {} },
    { key: 3300, header: 'CNT', width: 5, style: {} },
    { key: 3400, header: '予約状態', width: 10, style: {} },
  ];

  let _bdys = [] as ht.ls;
  _i1zrs.filter((_i1z1z: ht.dz) => _i1z1z.i1zrs1100i >= 80).map((_i1zrz: ht.dz) => {
    const _i1z1s = _i1zrz?.cldz?.i1z1s;
    if (hf.f(_i1z1s)) {
      const _i1z4z = hf.get1(_i1zrz?.cldz?.i1z4s, {});
      _i1z1s.map((_i1z1z: ht.dz) => {
        const _i18rz = hf.get1(_i1zrz?.cldz?.i18rs, {});
        const _i15rz = hf.get1(_i18rz?.cldz?.i15rs, {});
        _bdys.push({
          1100: hfDTM.cvtDow(_i1zrz.i1zrd3100s),
          1200: ihd.r(ihd.f('i1z1c3100i').ls, _i1z1z.i1z1c3100i),
          1300: hfDTM.cvtDay(_i1zrz.i1zrd3100s), 
          1400: `${_i1z1z.i1z1a1100i}:00〜${_i1z1z.i1z1a1200i}:00`,
//          1500: _i18rz.i18rac100s,
          1500: _i15rz._pfx,
          1600: _i1z1z.i1z1a2100s,
          2110: _i1z4z.i1z4a1100i,
          2120: _i1z4z.i1z4a1200i,
          2210: _i1z4z.i1z4a2100i,
          2220: _i1z4z.i1z4a2200i,
          2230: _i1z4z.i1z4a2300i,
          2240: _i1z4z.i1z4a2400i,
          2250: _i1z4z.i1z4a2500i,
          2260: _i1z4z.i1z4a2600i,
          2270: _i1z4z.i1z4a2700i,
          2280: _i1z4z.i1z4a2800i,
          2290: _i1z4z.i1z4a2900i,
          2310: _i1z4z.i1z4a3100i,
          2320: _i1z4z.i1z4a3200i,
          2330: _i1z4z.i1z4a3300i,
          3100: _i1zrz._icn,
          3200: _i18rz._pfx,
          3300: 1,
          3400: ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i),
        });
      })
    }
  });

  hfXLS.saveAsync({
    fileName: _fileName,
    shts: [
      {
        shtName: _shtName,
        hdrs: _hdrs,
        bdys: _bdys,
      }
    ]
  })

};
